"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RowTransformerValidator = void 0;
var lodash_isfunction_1 = __importDefault(require("lodash.isfunction"));
var types_1 = require("../types");
var RowTransformerValidator = /*#__PURE__*/function () {
  function RowTransformerValidator() {
    _classCallCheck(this, RowTransformerValidator);
    this._rowTransform = null;
    this._rowValidator = null;
  }
  // eslint-disable-next-line @typescript-eslint/no-shadow
  _createClass(RowTransformerValidator, [{
    key: "rowTransform",
    set: function set(transformFunction) {
      if (!lodash_isfunction_1.default(transformFunction)) {
        throw new TypeError('The transform should be a function');
      }
      this._rowTransform = RowTransformerValidator.createTransform(transformFunction);
    }
  }, {
    key: "rowValidator",
    set: function set(validateFunction) {
      if (!lodash_isfunction_1.default(validateFunction)) {
        throw new TypeError('The validate should be a function');
      }
      this._rowValidator = RowTransformerValidator.createValidator(validateFunction);
    }
  }, {
    key: "transformAndValidate",
    value: function transformAndValidate(row, cb) {
      var _this = this;
      return this.callTransformer(row, function (transformErr, transformedRow) {
        if (transformErr) {
          return cb(transformErr);
        }
        if (!transformedRow) {
          return cb(null, {
            row: null,
            isValid: true
          });
        }
        return _this.callValidator(transformedRow, function (validateErr, validationResult) {
          if (validateErr) {
            return cb(validateErr);
          }
          if (validationResult && !validationResult.isValid) {
            return cb(null, {
              row: transformedRow,
              isValid: false,
              reason: validationResult.reason
            });
          }
          return cb(null, {
            row: transformedRow,
            isValid: true
          });
        });
      });
    }
  }, {
    key: "callTransformer",
    value: function callTransformer(row, cb) {
      if (!this._rowTransform) {
        return cb(null, row);
      }
      return this._rowTransform(row, cb);
    }
  }, {
    key: "callValidator",
    value: function callValidator(row, cb) {
      if (!this._rowValidator) {
        return cb(null, {
          row: row,
          isValid: true
        });
      }
      return this._rowValidator(row, cb);
    }
  }], [{
    key: "createTransform",
    value: function createTransform(transformFunction) {
      if (types_1.isSyncTransform(transformFunction)) {
        return function (row, cb) {
          var transformed = null;
          try {
            transformed = transformFunction(row);
          } catch (e) {
            return cb(e);
          }
          return cb(null, transformed);
        };
      }
      return transformFunction;
    }
  }, {
    key: "createValidator",
    value: function createValidator(validateFunction) {
      if (types_1.isSyncValidate(validateFunction)) {
        return function (row, cb) {
          cb(null, {
            row: row,
            isValid: validateFunction(row)
          });
        };
      }
      return function (row, cb) {
        validateFunction(row, function (err, isValid, reason) {
          if (err) {
            return cb(err);
          }
          if (isValid) {
            return cb(null, {
              row: row,
              isValid: isValid,
              reason: reason
            });
          }
          return cb(null, {
            row: row,
            isValid: false,
            reason: reason
          });
        });
      };
    }
  }]);
  return RowTransformerValidator;
}();
exports.RowTransformerValidator = RowTransformerValidator;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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